"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RowTransformerValidator = void 0;
var lodash_isfunction_1 = __importDefault(require("lodash.isfunction"));
var types_1 = require("../types");
var RowTransformerValidator = /*#__PURE__*/function () {
  function RowTransformerValidator() {
    _classCallCheck(this, RowTransformerValidator);
    this._rowTransform = null;
    this._rowValidator = null;
  }
  // eslint-disable-next-line @typescript-eslint/no-shadow
  _createClass(RowTransformerValidator, [{
    key: "rowTransform",
    set: function set(transformFunction) {
      if (!lodash_isfunction_1.default(transformFunction)) {
        throw new TypeError('The transform should be a function');
      }
      this._rowTransform = RowTransformerValidator.createTransform(transformFunction);
    }
  }, {
    key: "rowValidator",
    set: function set(validateFunction) {
      if (!lodash_isfunction_1.default(validateFunction)) {
        throw new TypeError('The validate should be a function');
      }
      this._rowValidator = RowTransformerValidator.createValidator(validateFunction);
    }
  }, {
    key: "transformAndValidate",
    value: function transformAndValidate(row, cb) {
      var _this = this;
      return this.callTransformer(row, function (transformErr, transformedRow) {
        if (transformErr) {
          return cb(transformErr);
        }
        if (!transformedRow) {
          return cb(null, {
            row: null,
            isValid: true
          });
        }
        return _this.callValidator(transformedRow, function (validateErr, validationResult) {
          if (validateErr) {
            return cb(validateErr);
          }
          if (validationResult && !validationResult.isValid) {
            return cb(null, {
              row: transformedRow,
              isValid: false,
              reason: validationResult.reason
            });
          }
          return cb(null, {
            row: transformedRow,
            isValid: true
          });
        });
      });
    }
  }, {
    key: "callTransformer",
    value: function callTransformer(row, cb) {
      if (!this._rowTransform) {
        return cb(null, row);
      }
      return this._rowTransform(row, cb);
    }
  }, {
    key: "callValidator",
    value: function callValidator(row, cb) {
      if (!this._rowValidator) {
        return cb(null, {
          row: row,
          isValid: true
        });
      }
      return this._rowValidator(row, cb);
    }
  }], [{
    key: "createTransform",
    value: function createTransform(transformFunction) {
      if (types_1.isSyncTransform(transformFunction)) {
        return function (row, cb) {
          var transformed = null;
          try {
            transformed = transformFunction(row);
          } catch (e) {
            return cb(e);
          }
          return cb(null, transformed);
        };
      }
      return transformFunction;
    }
  }, {
    key: "createValidator",
    value: function createValidator(validateFunction) {
      if (types_1.isSyncValidate(validateFunction)) {
        return function (row, cb) {
          cb(null, {
            row: row,
            isValid: validateFunction(row)
          });
        };
      }
      return function (row, cb) {
        validateFunction(row, function (err, isValid, reason) {
          if (err) {
            return cb(err);
          }
          if (isValid) {
            return cb(null, {
              row: row,
              isValid: isValid,
              reason: reason
            });
          }
          return cb(null, {
            row: row,
            isValid: false,
            reason: reason
          });
        });
      };
    }
  }]);
  return RowTransformerValidator;
}();
exports.RowTransformerValidator = RowTransformerValidator;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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